import { Component, Input, OnInit, AfterViewInit, NgZone } from '@angular/core';

import { PlayerPoint } from './point';
import { PlayerChangePositionService } from './player-change-position-service';


import {Globals} from "../../globals";

import Peaks from 'peaks.js';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.css']
})
export class PlayerComponent implements OnInit, AfterViewInit {

    @Input() stopPoints: {}[];
    @Input() previewMode: boolean;
    filePathAudio: string;
    filePathData: string;

    playerObject: any;
    isPlayed: boolean;

    hidePeacksContainer:boolean;

    viewInit = false;
    playerInit = false;

    globalPreviewMode: boolean;



    constructor(
        private playerChangePositionService: PlayerChangePositionService,
        private zone: NgZone,
        private globals: Globals

    ) {

        let interval = setInterval(() => {
            if(this.viewInit && this.playerInit){
                this._initPlayer();
                clearInterval(interval);
            }
        }, 100);
    }

    ngOnInit() {
        this.globalPreviewMode = this.globals.previeModeStatus();
    }

    ngAfterViewInit() {
        this.viewInit = true;
    }

    initPlayer() {
        this.playerInit = true;
    }

    reinit() {
        console.log('destroy');
        if(this.playerObject){
            this.playerObject.destroy();
            this.playerObject = null;
            this._initPlayer();
        }
    }

    _initPlayer() {
        if(this.playerObject){
            return;
        }

        console.log('Player Init');

        this.playerObject = Peaks.init({
            // Containing element
            container: document.getElementById('peaks-container'),

            // HTML5 Media element containing an audio track
            mediaElement: document.querySelector('audio'),

            dataUri: {
                arraybuffer: this.filePathData
            },

            height: 50,

            showPlayheadTime: false,

            zoomWaveformColor: 'rgba(255, 0, 0, 0.06)',

            overviewWaveformColor: 'rgba(0,0,0,0.1)',

            zoomLevels: [1024],

            axisLabelColor: '#ffbbbb',

            pointMarkerColor: '#FF0000',

        });

        this.playerObject.player.setSource(this.filePathAudio);

        setTimeout( () => {
            if (this.stopPoints && this.stopPoints.length) {
                this.playerObject.points.add(this.stopPoints);
            }
        }, 1000);

        this.playerObject.on('points.dragend', (point) => {
            console.log('DragPoint', point);
            this.playerChangePositionService.changePosition(point);
        });

        this.playerObject.on('peaks.ready', () => {
            if(this.previewMode){
                this.hidePeacksContainer=true;
            }
        });
    }

    ifPlayerInit() {
        return this.getPlayer();
    }


    getPlayer() {
        return this.playerObject ? this.playerObject.player : null;
    }

    play() {
        this.playerObject.player.play();
        this.isPlayed = true;
    }

    pause() {
        this.playerObject.player.pause();
        this.isPlayed = false;
    }

    getCurrentPosition() {
        return this.playerObject.player.getCurrentTime();
    }

    addPoint(point: PlayerPoint) {
        this.playerObject.points.add(point);
    }

    removePointById(id: number) {
        this.playerObject.points.removeById(id);
    }
}
